import { css } from '@emotion/react';
import { WIDTH_MAX, WIDTH_NAVIGATION_VIEW } from '@pages/Main/MainView/constants';

export const unInitialized = css({
  display: 'none'
});

export const mainContainer = css({
  display: 'flex'
});

export const contentContainer = css({
  width: WIDTH_MAX - WIDTH_NAVIGATION_VIEW,
  height: '1080px',
  paddingLeft: WIDTH_NAVIGATION_VIEW + 'px'
});

export const navContainer = css({
  position: 'fixed',
  height: '1080px',
  opacity: 0.8,
  zIndex: 5
});
